<template>
  <div>
    <div class="content-head">
      <div>
        <h2>污染物(经气象调整后)浓度等级</h2>
      </div>

      <div style="text-align: left">
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >什么是气象调整方法？<i class="header-icon el-icon-info"></i
              ></span>
            </template>
            <div>
              基于2011年3月到2019年2月累积八年的小时气象数据，对“2+66”城市分别构造基准气象条件，在此基准气象条件下计算各季节污染物的浓度，通过控制气象条件，捕捉潜在排放量的变化。具体来说，我们采用核估计方法，对各年份和季度的污染与气象数据建立调整模型，将该模型作用于八年基准气象的经验分布函数，计算调整均值。
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >污染物浓度分级标准（日均浓度）<i
                  class="header-icon el-icon-info"
                ></i
              ></span>
            </template>
            <div>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="level" label="污染等级">
                </el-table-column>
                <el-table-column prop="pm2_5">
                  <template slot="header" slot-scope="scope">
                    PM2.5(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="PM10" label="PM10">
                  <template slot="header" slot-scope="scope">
                    PM10(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="pm10_2_5" label="PM10-2.5">
                  <template slot="header" slot-scope="scope">
                    PM10-2.5(ug/m<sup>3</sup>)
                  </template>
                </el-table-column> -->
                <el-table-column prop="SO2" label="SO2">
                  <template slot="header" slot-scope="scope">
                    SO2(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="CO" label="CO">
                  <template slot="header" slot-scope="scope">
                    CO(mg/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="NO2" label="NO2">
                  <template slot="header" slot-scope="scope">
                    NO2(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
                <el-table-column prop="O3" label="O3">
                  <template slot="header" slot-scope="scope">
                    O3(ug/m<sup>3</sup>)
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <el-form class="textAlignLeft" v-if="this.assesscity.length > 1">
        <el-form-item label="评估年份">
          <!-- <el-date-picker
            v-model="assessYear"
            type="year"
            placeholder="选择评估年份"
            :picker-options="pickerOptions"
            @change="assessYearChange"
            size="mini"
          ></el-date-picker> -->

          <el-select
            size="mini"
            v-model="assessYear"
            placeholder="请选择"
            @change="assessYearChange"
          >
            <el-option
              v-for="item in Years"
              :key="item"
              :label="item + '年'"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button
          type="success"
          icon="el-icon-download"
          @click="downloadImage"
          :loading="imageDownloading"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div id="area-ext-chart-canvas">
      <div class="content-body" :style="{ padding: '20px' }">
        <div
          id="area-ext-chart"
          :style="{ height: eleheight + 'px', paddingRight: '1px' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.el-row {
  margin-bottom: 15px;
}
</style>

<script>
import {
  getPullStand,
  getMonitorPulls,
  get_pull_level,
} from "@/assets/js/my-utils.js";

import { GenerateMapImgFromDom } from "@/assets/js/utils-map.js";

export default {
  name: "Platform",
  data() {
    return {
      colors: [
        "#00E400",
        "#FFFF00",
        "#FF7E00",
        "#FF0000",
        "#99004C",
        "#7E0023",
      ],
      tableData: [
        {
          level: "优",
          pm2_5: "≤35",
          PM10: "≤50",
          // pm10_2_5: "≤50",
          SO2: "≤50",
          CO: "≤2",
          NO2: "≤40",
          O3: "≤100",
        },
        {
          level: "良",
          pm2_5: "≤75",
          PM10: "≤150",
          SO2: "≤150",
          CO: "≤4",
          NO2: "≤80",
          O3: "≤160",
        },
        {
          level: "轻度污染",
          pm2_5: "≤115",
          PM10: "≤250",
          SO2: "≤475",
          CO: "≤14",
          NO2: "≤180",
          O3: "≤215",
        },
        {
          level: "中度污染",
          pm2_5: "≤150",
          PM10: "≤350",
          SO2: "≤800",
          CO: "≤24",
          NO2: "≤280",
          O3: "≤265",
        },
        {
          level: "重度污染",
          pm2_5: "≤250",
          PM10: "≤420",
          SO2: "≤1600",
          CO: "≤36",
          NO2: "≤565",
          O3: "≤800",
        },
        {
          level: "严重污染",
          pm2_5: ">250",
          PM10: ">420",
          SO2: ">1600",
          CO: ">36",
          NO2: ">565",
          O3: ">800",
        },
      ],

      assessYear: "2023",
      Years: [
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
        "2013",
      ],

      chart: [],
      cityname: ["北京"],
      height: 600,

      assessMonitorIndex: "1",
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > 2019 || time.getFullYear() < 2013;
        },
      },
    };
  },
  computed: {
    eleheight: function () {
      return 400;
      // let sub = this.assesscity.length * 50;
      // return sub < 600 ? sub : 600;
      // // `this` 指向 vm 实例
      // return this.message.split("").reverse().join("");
    },
  },
  methods: {
    downloadImage() {
      let imageDom = document.getElementById("area-ext-chart-canvas");

      let title = this.assessYear + "年各城市污染物分级情况";

      if (this.assesscity.length == 1) {
        title = this.assesscity[0][1] + "市各年污染物分级情况";
      }

      GenerateMapImgFromDom(imageDom, title + ".png");
    },

    assessYearChange() {
      // this.assessYear = this.assessYear.getFullYear() + "";
      this.updateCharts();
    },

    getMonitorData() {
      const that = this;

      if (this.assesscity.length > 1) {

        let url = "/AQAssess/getAreaMonitor/" + this.assessYear;
        

        this.$axios
          // .post("/AQAssess/getData.php", {
          //   database: "area_monitor",
          //   year: this.assessYear,
          // })
          .get(url)
          .then((res) => {
            let pulldata = [];
            res.data.forEach((element) => {
              that.assesscity.forEach((elem) => {
                if (elem[1] == element[0]) {
                  pulldata.push(element);
                }
              });
            });

            that.drawAreaPullsExtChart(
              that.chart[0],
              pulldata,
              that.assessYear
            );
          });
      } else {
        this.$axios
          // .post("/AQAssess/getData.php", {
          //   database: "city_ext",
          //   city_en: that.assesscity[0][2],
          // })
          .get("/AQAssess/getCityEXT/"+that.assesscity[0][2])
          .then((res) => {
            // console.log(res.data);
            that.drawAreaPullsExtChart(
              that.chart[0],
              res.data,
              that.assessYear,
              "sigle",
              that.assesscity[0][1]
            );
          });
        // .catch((e) => {
        //   this.$message({
        //     type: "info",
        //     message: "获取" + this.cityname + "超标污染物数据失败",
        //   });
        // });
      }
    },

    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getMonitorData();
    },

    drawAreaPullsExtChart(chart, data, year, type = "mutl", city = null) {
      let formatterData = this.areaPullsExtDataFormatter(data, type);
      let pulls = formatterData.pulls;
      let levels = ["优", "良", "轻度污染", "中度污染", "重度污染", "严重污染"];
      // console.log(formatterData.data);
      let xAxisData = null;
      if (type != "mutl") {
        xAxisData = formatterData.years;
      } else {
        xAxisData = formatterData.cities;
      }
      
      let title = year + "年各城市污染物分级情况";
      if (type != "mutl") {
        title = city + "市各年污染物分级情况";
      }
      let option = {
        title: {
          text: title,
          left: "center",
          padding: 5,
        },
        tooltip: {
          // trigger: "axis",
          // position: "top",
          // axisPointer: {
          //   axis: "x",
          // },
          trigger: "item",
          formatter: function (params) {
            // console.log(params);
            let text;
            if (type == "mutl") {
              // text = year + "年" + params[0].axisValue + "<br>";
              text =
                params.marker +
                year +
                "年" +
                xAxisData[params.value[0]] +
                "<br>" +
                pulls[params.value[1]] +
                "浓度:" +
                parseFloat(params.value[3]).toFixed(2) +
                "<br>" +
                "污染等级为：" +
                levels[params.value[2] - 1];
            } else {
              text =
                params.marker +
                params.value[0] +
                "年" +
                city +
                "市<br>" +
                params.value[1] +
                "浓度：" +
                parseFloat(params.value[3]).toFixed(2) +
                "<br>" +
                "污染等级为：" +
                levels[params.value[2] - 1];
            }

            //
            // params.forEach((param, idx) => {
            //   text +=
            //     param.marker + param.data[1] + levels[param.data[2]] + "<br>";
            // });
            return text;
          },
        },
        grid: {
          top: 80,
          left: 50,
          right: 10,
        },
        xAxis: [
          {
            type: "category",
            data: xAxisData,
            splitArea: {
              show: true,
            },
          },
        ],
        yAxis: {
          type: "category",
          data: pulls,
          splitArea: {
            show: true,
          },
        },

        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            // left: "93%",
            bottom: "5",
            startValue: 0,
            endValue: 20,
          },
        ],

        visualMap: {
          type: "piecewise",
          show: true,
          pieces: [
            { gt: 0, lte: 1, label: "优", color: "#00E400" },
            { gt: 1, lte: 2, label: "良", color: "#FFFF00" },
            { gt: 2, lte: 3, label: "轻度污染", color: "#FF7E00" },
            { gt: 3, lte: 4, label: "中度污染", color: "#FF0000" },
            { gt: 4, lte: 5, label: "重度污染", color: "#99004C" },
            { gt: 5, lte: 6, label: "严重污染", color: "#7E0023" },
          ],
          right: "center",
          orient: "horizontal",
          top: 30,
          dimension: 2,
        },
        series: [
          {
            // name: "Punch Card",
            type: "heatmap",
            data: formatterData.data,
            // label: {
            //   show: true,
            // },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.1)",
            },
          },
        ],
        animationDelay: function (idx) {
          return idx * 100;
        },
      };
      chart.setOption(option);
      chart.resize();
      chart.hideLoading();
    },

    areaPullsExtDataFormatter(data, type = "mutl") {
      let ext_data = [];
      let cities = [];
      var pulls = ["PM2.5", "PM10", "SO2", "CO", "NO2", "O3"];
      let years = [];

      if (type == "mutl") {
        // data.forEach((element) => {
        //   pulls.forEach((pull, idx) => {
        //     ext_data.push([
        //       element[0],
        //       pull,
        //       get_pull_level(pull, parseFloat(element[idx + 1])),
        //     ]);
        //   });
        // });

        data.forEach((element, idy) => {
          pulls.forEach((pull, idx) => {
            ext_data.push([
              idy,
              idx,
              get_pull_level(pull, parseFloat(element[idx + 1])),
              parseFloat(element[idx + 1]),
            ]);
          });

          cities.push(element[0]);
        });

        return {
          pulls: pulls,
          data: ext_data,
          cities: cities,
        };
      } else {

        

        data.forEach((element) => {
          ext_data.push([
            element[2] - 2013,
            element[1],
            get_pull_level(element[1], parseFloat(element[3])),
            parseFloat(element[3]),
          ]);

          years.push(element[2]);
        });
        years = Array.from(new Set(years));
        years = years.sort((a, b) => {
          return parseInt(a) - parseInt(b);
        });
        return {
          pulls: pulls,
          data: ext_data,
          years: years,
        };
      }
    },
  },
  created() {},
  mounted() {
    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("area-ext-chart"))
      );

      this.updateCharts();
    }

    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },

    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;
      if (this.show) {
        this.updateCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];
        this.chart.push(
          this.$echarts.init(document.getElementById("area-ext-chart"))
        );

        this.updateCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
};
</script>



